import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import SEOHTMLText from 'uiComponents/atoms/SEOHTMLText/SEOHTMLText'
import { HeadingM, HeadingS } from 'uiComponents/atoms/Text/Headings'
import { fsS, fsXS, fsXXS } from 'uiComponents/constants/typography'

const Section = styled.section`
  width: 100%;
`

const Title = styled(HeadingM)`
  margin-bottom: 15px;
`

const StyledSeoTitle = styled(Title)`
  font-size: ${fsS}px;
`

const StyledSeoHtmlText = styled(SEOHTMLText)`
  margin-bottom: 30px;

  & > h1 {
    font-size: ${fsS}px;
  }
  & > h2 {
    font-size: ${fsXS}px;
  }
  & > p {
    font-size: ${fsXXS}px;
  }
`

export const Links = styled.div`
  display: flex;
`

export const LinkBlock = styled.div`
  padding-right: 20px;

  &:last-child {
    padding-right: 0;
  }
`

export const LinkHeader = styled(HeadingS)`
  padding-bottom: 10px;
  font-size: ${fsXS}px;
`

export const StyledLink = styled(Link)`
  font-size: ${fsXXS}px;
  :hover {
    text-decoration: underline;
  }
`

export type SEOLinks = Array<{
  headerText: string
  values: Array<{
    id: string
    text: string
    to: string
  }>
}>

interface IStreamSEOProps {
  seoText?: string
  seoLinks?: SEOLinks
  title?: string
}

const StreamSEO: FC<IStreamSEOProps> = ({ seoLinks, seoText, title }) => {
  return (
    <div className="container">
      <Section>
        {title && <StyledSeoTitle as="h1">{title}</StyledSeoTitle>}
        {seoText && <StyledSeoHtmlText text={seoText} />}
        {seoLinks && (
          <Links data-testid="Links">
            {seoLinks.map((seoLink, ii) => (
              <LinkBlock key={ii}>
                <LinkHeader data-testid="LinkHeader">
                  {seoLink.headerText}
                </LinkHeader>
                <ul>
                  {seoLink.values.map(value => (
                    <li key={value.id}>
                      <StyledLink data-testid="Link" to={value.to}>
                        {value.text}
                      </StyledLink>
                    </li>
                  ))}
                </ul>
              </LinkBlock>
            ))}
          </Links>
        )}
      </Section>
    </div>
  )
}

export default StreamSEO
